/**
 * Legal values for the `editability` property on a table field or a collection schema.
 *
 * inline: cells can be edited directly in the table view.
 * form: the row can be edited through the row form ("Edit Row").
 *
 * The property is an array of these values. An empty or missing array means both.
 * Values are exact lowercase tokens, matching the iOS and Android SDKs.
 */
const inline = 'inline';
const form = 'form';

export default {
  inline,
  form,
};
